module.exports = __webpack_public_path__ + "img/siemens.21ff3512.svg";